import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private readonly runtimeConfigurationKeys = [
    'apiURL',
    'userType',
    'compactViewWidth',
    'oldAppURL',
    'production',
    'reconnectionTime',
    'appName',
    'tooltipDelay',
    'serviceAppUrl',
    'menuPosition'
  ];

  inMemoryStorage: { [key: string]: string } = {};
  length = 0;

  isSupported() {
    try {
      const testKey = "__some_random_key_you_are_not_going_to_use__";
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      console.error("LocalStorage is not Available.");
      return false;
    }
  }

  clear(): void {
    if (this.isSupported()) {
      localStorage.clear();
    } else {
      this.inMemoryStorage = {};
    }
  }

  clearCachedData(): void {
    if (this.isSupported()) {
      const keysToRemove: string[] = [];

      for (let index = 0; index < localStorage.length; index++) {
        const key = localStorage.key(index);

        if (key && !this.runtimeConfigurationKeys.includes(key)) {
          keysToRemove.push(key);
        }
      }

      keysToRemove.forEach(key => localStorage.removeItem(key));
    } else {
      this.inMemoryStorage = Object.keys(this.inMemoryStorage)
        .filter(key => this.runtimeConfigurationKeys.includes(key))
        .reduce((storage, key) => {
          storage[key] = this.inMemoryStorage[key];
          return storage;
        }, {});
    }
  }

  getItem(name: string): any | null {
    if (this.isSupported()) {
      return localStorage.getItem(name);
    }
    if (this.inMemoryStorage.hasOwnProperty(name)) {
      return this.inMemoryStorage[name];
    }
    return null;
  }

  getItemJSON(name: string): any | null {
    return JSON.parse(this.getItem(name));
  }

  key(index: number): string | null {
    if (this.isSupported()) {
      return localStorage.key(index);
    } else {
      return Object.keys(this.inMemoryStorage)[index] || null;
    }
  }

  removeItem(name: string): void {
    if (this.isSupported()) {
      localStorage.removeItem(name);
    } else {
      delete this.inMemoryStorage[name];
    }
  }

  setItem(name: string, value: string): void {
    if (this.isSupported()) {
      localStorage.setItem(name, value);
    } else {
      this.inMemoryStorage[name] = value;
    }
  }

  setItemJSON(name: string, value: any) {
    this.setItem(name, JSON.stringify(value));
  }

}
